import React from 'react'
import BoldTypography from "components/BoldTypography";
import PropTypes from "prop-types";
import {makeStyles} from "@material-ui/core/styles";
import Typography from "components/Typography";
import Tr from "translations/Translations";
import clsx from "clsx";

const useStyle = makeStyles(theme => ({
    root: {
        borderBottom: "solid 1px",
        marginBottom: theme.spacing(3),
        paddingBottom: theme.spacing()
    },
    titleRoot: {
        '&>*:nth-child(1)': {
            flexGrow: 1
        }
    },
    content: {
        marginLeft: theme.spacing(2)
    }
}))

function InfoEntry(
    {
        label,
        className,
        children
    }) {
    const classes = useStyle();


    return <div className={clsx(classes.root, className)}>
        <BoldTypography component="span">{`${Tr(label)}: `}</BoldTypography><Typography component="span">{children}</Typography>
    </div>

}

InfoEntry.propTypes = {
    label: PropTypes.string.isRequired,
    collapsible: PropTypes.bool
}

export default InfoEntry;